import errors from './errors/index.js';
import translation from './translation/index.js';
const ptBR = Object.freeze({
    translation,
    errors,
});
export default ptBR;
